module.exports = __webpack_public_path__ + "media/images/carrier_logo-a0cc32426de021a697a3098580cb1190.jpg";